<template>
  <div>
    <!-- <vuex-breadcrumb></vuex-breadcrumb> -->
    <h1>{{computedHeading}}</h1>
    <product-item-create
      :ams_template="ams_template"
      :reroute="reroute"
    ></product-item-create>
  </div>
</template>

<script>
// import VuexBreadcrumb from './VuexBreadcrumb.vue'
import ProductItemCreate from './ProductItemCreate.vue'
import {humanize, singularize} from '@/utils'

export default {
  components: {
    // VuexBreadcrumb,
    ProductItemCreate
  },
  computed: {
     computedHeading() {
      if (this.ams_template) {
        return "Create " + singularize(humanize(this.ams_template['type']))
      }
      else {
        return "Create Product Item"
      }
     }
  },
  props: {
    reroute: {
      Type: Boolean,
      default: true
    },
    ams_template: {
      Type: Object
    }
  }
}
</script>